import React, { useState } from 'react';
import get from 'lodash/get';
import { useFormikContext } from 'formik';
export var ProgressiveDisclosure = function (_a) {
    var dependOnPath = _a.dependOnPath, _b = _a.isEnabled, isEnabled = _b === void 0 ? false : _b, children = _a.children;
    var _c = useFormikContext(), values = _c.values, errors = _c.errors;
    var _d = useState(false), wasDisclosed = _d[0], setWasDisclosed = _d[1];
    if (!isEnabled || wasDisclosed) {
        return React.createElement(React.Fragment, null, children);
    }
    var dependFieldError = get(errors, dependOnPath);
    var dependFieldValue = get(values, dependOnPath);
    if (!!dependFieldError || typeof dependFieldValue === 'undefined') {
        return null;
    }
    if (!wasDisclosed) {
        setWasDisclosed(true);
    }
    return React.createElement(React.Fragment, null, children);
};
